var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48713 13.25C6.27773 13.25 6.10252 13.1794 5.96149 13.0384C5.82046 12.8974 5.74995 12.7222 5.74995 12.5128V7.68906L1.08491 1.76281C0.924656 1.54913 0.90142 1.32691 1.0152 1.09615C1.12898 0.865383 1.32101 0.75 1.5913 0.75H12.4086C12.6788 0.75 12.8709 0.865383 12.9847 1.09615C13.0984 1.32691 13.0752 1.54913 12.9149 1.76281L8.24991 7.68906V12.5128C8.24991 12.7222 8.17939 12.8974 8.03836 13.0384C7.89734 13.1794 7.72212 13.25 7.51272 13.25H6.48713ZM6.99993 7.24998L11.1249 1.99998H2.87493L6.99993 7.24998Z",
    fill: "#66696C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.2daa5500462416951ad026df1adf17fe.svg";
export { ForwardRef as ReactComponent };